import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IAlbum, Lightbox } from 'ngx-lightbox';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { ProductTypes } from 'src/app/model/product/product-type';
import { SUB_PROJECT_TYPES } from 'src/app/model/project/sub-project';
import { CompletedSubProjectItem } from '../helper/client-corner-home-page-completed-subprojects-helper';

@Component({
  selector: 'client-corner-home-page-completed-subproject-item',
  templateUrl:
    './client-corner-home-page-completed-subproject-item.component.html',
  styleUrls: [
    './client-corner-home-page-completed-subproject-item.component.scss'
  ]
})
export class ClientCornerHomePageCompletedSubProjectItemComponent {
  @Input()
  subProject: CompletedSubProjectItem;

  SUB_PROJECT_TYPES = SUB_PROJECT_TYPES;

  backgroundImageStyle: any;

  isIPBoardProject: boolean;

  constructor(private _lightbox: Lightbox, private router: Router) {}

  ngOnInit(): void {
    this.isIPBoardProject =
      CollectionHelper.isPopulated(this.subProject.products) &&
      this.subProject.products.some(
        p => p.type === ProductTypes.IP_BOARD.value
      );
    if (
      this.subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT ||
      this.subProject.type === SUB_PROJECT_TYPES.REPO
    ) {
      this.setBaseProjectBackgroundImage();
    } else {
      this.setAdjustmentBackgroundImage();
    }
  }

  private setBaseProjectBackgroundImage(): void {
    if (
      CollectionHelper.isPopulated(this.subProject.products) &&
      this.subProject.products[0].firstAsset != null
    ) {
      this.backgroundImageStyle = this.getBackgroundImageStyle(
        `/api/assets/${this.subProject.products[0].firstAsset.asset.uuid}/330/225`
      );
    }
  }

  private setAdjustmentBackgroundImage(): void {
    if (this.subProject.firstAsset != null) {
      this.backgroundImageStyle = this.getBackgroundImageStyle(
        `/api/assets/${this.subProject.firstAsset.asset.uuid}/330/225`
      );
    }
  }

  private getBackgroundImageStyle(url: string): any {
    return {
      'background-image': `url('${url}')`,
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'background-size': 'contain'
    };
  }

  openAlbum(album: IAlbum[]): void {
    if (!CollectionHelper.isPopulated(album)) {
      return;
    }
    this._lightbox.open(album);
  }

  openProject(): void {
    this.router.navigate([
      '/klant-opdracht',
      this.subProject.projectId,
      this.subProject.id
    ]);
  }
}
